import { Quote } from "lucide-react";
import Reveal from "@/components/Reveal";

const testimonials = [
  {
    quote:
      "Future Solutions took our response time from 14 hours to under 20 minutes. Our CSAT jumped 22 points in one quarter — they're not a vendor, they're our support team.",
    name: "Sarah Mitchell",
    role: "COO, Lumen Retail",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTU1NTgxOXww&ixlib=rb-4.1.0&q=85",
    testid: "testimonial-sarah-mitchell",
  },
  {
    quote:
      "We handed them 40,000 backlogged records. Clean, verified and delivered two weeks early. The accuracy reporting alone was worth the switch.",
    name: "David Okafor",
    role: "VP Operations, Finlytic",
    img: "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    testid: "testimonial-david-okafor",
  },
  {
    quote:
      "Scaling from 5 to 30 agents took them ten days. I've worked with three BPOs before — nobody onboarded faster or communicated better.",
    name: "Marcus Bennett",
    role: "Founder, CloudHire",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTU1NTgxOXww&ixlib=rb-4.1.0&q=85",
    testid: "testimonial-marcus-bennett",
  },
];

const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="border-t border-white/10 bg-[#0D1424] py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-sky-400 md:text-sm">
          03 — Client Proof
        </p>
        <h2 className="max-w-3xl font-display text-4xl font-bold tracking-tight md:text-6xl">
          Trusted by teams that can't afford downtime.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 md:grid-cols-3">
        {testimonials.map((t, i) => (
          <Reveal
            key={t.testid}
            delay={i * 0.12}
            className={`group flex flex-col justify-between border border-white/10 bg-[#0A0F1C] p-8 transition-colors duration-500 hover:border-sky-400/40 ${
              i === 1 ? "md:translate-y-10" : ""
            }`}
          >
            <div>
              <Quote className="h-7 w-7 text-sky-400" />
              <p data-testid={t.testid} className="mt-6 text-base leading-relaxed text-slate-300">
                "{t.quote}"
              </p>
            </div>
            <div className="mt-10 flex items-center gap-4">
              <img
                src={t.img}
                alt={t.name}
                loading="lazy"
                className="h-12 w-12 rounded-full border border-white/20 object-cover grayscale transition-all duration-500 group-hover:grayscale-0"
              />
              <div>
                <p className="text-sm font-bold text-white">{t.name}</p>
                <p className="text-xs text-slate-500">{t.role}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
